{
  "bell_label": "Notifications",
  "panel_title": "Notifications",
  "mark_all_read": "Tout marquer comme lu",
  "empty": {
    "title": "Aucune notification",
    "description": "Vous recevrez ici les mises à jour de vos commandes et promotions."
  },
  "types": {
    "order_confirmed": "Commande confirmée",
    "order_shipped": "Commande expédiée",
    "order_delivered": "Commande livrée",
    "payment_received": "Paiement reçu",
    "payment_failed": "Échec du paiement",
    "return_approved": "Retour approuvé",
    "return_rejected": "Retour refusé",
    "promo": "Promotion",
    "loyalty_milestone": "Fidélité",
    "stock_alert": "Alerte stock",
    "welcome": "Bienvenue"
  },
  "channels": {
    "sms": "SMS",
    "whatsapp": "WhatsApp",
    "email": "E-mail",
    "push": "Notifications push",
    "in_app": "Dans l'application"
  },
  "languages": {
    "fr": "Français",
    "wo": "Wolof",
    "en": "English"
  },
  "preferences": {
    "channels_title": "Canaux de notification",
    "channels_description": "Choisissez comment vous souhaitez recevoir vos notifications.",
    "quiet_hours_title": "Heures silencieuses",
    "quiet_hours_description": "Aucune notification push ou SMS ne sera envoyée pendant cette période.",
    "quiet_start": "Début",
    "quiet_end": "Fin",
    "language_title": "Langue des notifications",
    "save": "Enregistrer",
    "saving": "Enregistrement..."
  },
  "timeAgo": {
    "now": "À l'instant",
    "minutes_one": "Il y a {{count}} minute",
    "minutes_other": "Il y a {{count}} minutes",
    "hours_one": "Il y a {{count}} heure",
    "hours_other": "Il y a {{count}} heures",
    "days_one": "Il y a {{count}} jour",
    "days_other": "Il y a {{count}} jours"
  }
}
